import type { CompiledCreatureTemplate } from "../creatures/template.ts";
import { type CompiledNpcTemplate, plainName } from "./compiled.ts";

/**
 * An NPC template in the shape the creature store reads (ADR-136 decision 1): a folk row of the store holds the same
 * columns as a wild one, so every read of a row's template (its name, pace, rests and, once it fights, its abilities and
 * ranges) works on either. A template that names no fight fields gets the placeholders that keep the creature rules
 * inert: one health, no ability, no notice range and no leash. Its creature temperament is `neutral`, which notices
 * no one by range; the NPC's own temperament is the placement's. Pure.
 *
 * @param template The compiled NPC template.
 * @returns The creature-shaped template, carrying the NPC's `appearance`, its index in the version's NPC look table.
 */
export function folkTemplateOf(template: CompiledNpcTemplate): CompiledCreatureTemplate {
  const noticeTiles = template.noticeTiles ?? 0;
  const leashTiles = template.leashTiles ?? 0;
  return {
    id: template.id,
    name: plainName(template.name.text),
    look: template.look,
    level: template.level,
    health: template.health ?? 1,
    pace: template.pace,
    abilities: template.abilities ?? [],
    noticeTiles,
    leashTiles,
    restTicks: template.restTicks,
    xp: template.xp ?? 0,
    temperament: "neutral",
    threatTiles: Math.max(noticeTiles, leashTiles),
    appearance: template.appearance,
  };
}
